module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/product-images/product-06-c870dfc640f6394d62fccd786ae8927b.webp";